<template>
    <section
        v-if="tours.length"
        class="tour-recommendations"
    >
        <h2 class="tour-recommendations__title u-header-3">
            More tours to explore
        </h2>

        <div class="tour-recommendations__grid">
            <TourCard
                v-for="tour in tours"
                :key="tour.uuid"
                :tour="tour"
                @select="track(tour, $event)"
            />
        </div>
    </section>
</template>

<script setup>
import TourCard from '~/components/tour-card/tour-card.vue'

const { tours = [] } = defineProps({
    tours: {
        type: Array,
        default: () => [],
    },
})

const { capture } = useTracking()

function track(tour, action) {
    capture('related_tour_clicked', {
        placement: 'tour-recommendations',
        target_slug: tour.full_slug,
        action,
    })
}
</script>

<style lang="scss" scoped>
@use '@vemedia/bcn-components/scss/responsive' as *;

.tour-recommendations {
    margin-block: 2rem;

    &__title {
        margin-bottom: 1.25rem;
    }

    &__grid {
        display: grid;
        gap: 1.5rem;

        @include tablet {
            grid-template-columns: repeat(2, 1fr);
        }

        @include desktop {
            grid-template-columns: repeat(3, 1fr);
        }
    }
}
</style>
